var chunkMapping = {
	"46": [
		20046
	],
	"104": [
		90104
	],
	"202": [
		70202
	],
	"1049": [
		31049
	],
	"1132": [
		91132
	],
	"1987": [
		81987
	],
	"2757": [
		62757
	],
	"3116": [
		23116
	],
	"3355": [
		73355
	],
	"3487": [
		73487
	],
	"3920": [
		63920
	],
	"4430": [
		34430
	],
	"4659": [
		54659
	],
	"4712": [
		84712
	],
	"5568": [
		15568
	],
	"5659": [
		75659
	],
	"5682": [
		25682
	],
	"5763": [
		75763
	],
	"6013": [
		46013
	],
	"6711": [
		16711
	],
	"6779": [
		6779
	],
	"7208": [
		51270,
		82759
	],
	"7572": [
		87572
	],
	"7998": [
		97998
	],
	"8435": [
		8435
	],
	"9106": [
		59106
	],
	"9123": [
		89123
	]
};
var idToExternalAndNameMapping = {
	"6779": [
		"default",
		"./RegulatoryBundleList",
		70958
	],
	"8435": [
		"default",
		"./AllocateNumbers",
		70958
	],
	"15568": [
		"default",
		"./EndCustomersList",
		70958
	],
	"16711": [
		"default",
		"./RegulatoryBundleView",
		70958
	],
	"20046": [
		"default",
		"./EndCustomersAddServices",
		70958
	],
	"23116": [
		"default",
		"./EditBundleSuccess",
		70958
	],
	"25682": [
		"default",
		"./OrdersList",
		70958
	],
	"31049": [
		"default",
		"./EndCustomersAdd",
		70958
	],
	"34430": [
		"default",
		"./OrderComments",
		70958
	],
	"46013": [
		"default",
		"./CeaseNumbers",
		70958
	],
	"51270": [
		"default",
		"./i18n",
		78609
	],
	"54659": [
		"default",
		"./LandingPage",
		70958
	],
	"59106": [
		"default",
		"./CountryOverview",
		70958
	],
	"62757": [
		"default",
		"./AddBundle",
		70958
	],
	"63920": [
		"default",
		"./BundleManagementDetails",
		70958
	],
	"70202": [
		"default",
		"./NumberRequest",
		70958
	],
	"73355": [
		"default",
		"./OrderDetails",
		70958
	],
	"73487": [
		"default",
		"./RegulationsView",
		70958
	],
	"75659": [
		"default",
		"./EditEndCustomerDetails",
		70958
	],
	"75763": [
		"default",
		"./EndCustomerDetails",
		70958
	],
	"81987": [
		"default",
		"./BundleManagementSuccess",
		70958
	],
	"82759": [
		"default",
		"./i18n",
		70958
	],
	"84712": [
		"default",
		"./MyNumbers",
		70958
	],
	"87572": [
		"default",
		"./CeaseSuccess",
		70958
	],
	"89123": [
		"default",
		"./CountryManage",
		70958
	],
	"90104": [
		"default",
		"./EditBundle",
		70958
	],
	"91132": [
		"default",
		"./BundlesManagementList",
		70958
	],
	"97998": [
		"default",
		"./Provider",
		70958
	]
};
__webpack_require__.f.remotes = function(chunkId, promises) {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach(function(id) {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = function(error) {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = function() {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = function(fn, arg1, arg2, d, next, first) {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then(function(result) { return next(result, d); }, onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = function(external, _, first) { return external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError(); };
			var onInitialized = function(_, external, first) { return handleFunction(external.get, data[1], getScope, 0, onFactory, first); };
			var onFactory = function(factory) {
				data.p = 1;
				__webpack_require__.m[id] = function(module) {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}